import _pt from "prop-types";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import ActionMenu from './ActionMenu';
import DeConsumerMessage from './DeConsumerMessage';
import Logo from '../Logo/Logo';
import Menu from './Menu';
import React, { useState } from 'react';
import { SkipNav } from '@cmsgov/design-system';
import { getLanguage, tWithLanguage } from '../i18n';
import classnames from 'classnames';
import defaultMenuLinks from './defaultMenuLinks';
export var VARIATION_NAMES = {
  LOGGED_IN: 'logged-in',
  LOGGED_OUT: 'logged-out'
};
/**
 * The top-level component, responsible for maintaining the
 * header's state (like whether the mobile menu is expanded) and
 * determining which variation of the header to display
 */

export var Header = function Header(props) {
  var _props$initialLanguag, _props$logoClassName;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openMenu = _useState2[0],
      setOpenMenu = _useState2[1];

  var isControlledMenu = props.isMenuOpen !== undefined && props.onMenuToggle !== undefined;
  var t = tWithLanguage(props.initialLanguage);

  if (props.initialLanguage) {
    console.warn("[Deprecated]: Please remove the 'initialLanguage' prop in <Header> in favor of global language setting. This prop is deprecated and will be removed in a future release.");
  }
  /**
   * Determines which variation of the header should be displayed,
   * based on the props being passed into the component.
   * @returns {String} Variation name
   */


  function variation() {
    if (props.loggedIn) {
      // Logged-in state, with minimal navigation
      return VARIATION_NAMES.LOGGED_IN;
    } else {
      // Logged-out state, either Learn or Product
      return VARIATION_NAMES.LOGGED_OUT;
    }
  }

  function isLoggedIn() {
    return variation() === VARIATION_NAMES.LOGGED_IN;
  }
  /**
   * Content rendered within <Menu>, before the list of links
   * @returns {Node}
   */


  function beforeMenuLinks() {
    if (isLoggedIn() && props.firstName) {
      return /*#__PURE__*/React.createElement("div", {
        className: "ds-u-sm-display--none ds-u-border-bottom--1 ds-u-margin-x--1 ds-u-padding-y--1 hc-c-header__name"
      }, props.firstName);
    }
  }
  /**
   * Event handler for when the "Menu" or "Close" button
   * within ActionMenu is clicked.
   */


  function handleMenuToggleClick() {
    if (!isControlledMenu) {
      setOpenMenu(!openMenu);
    } else {
      props.onMenuToggle();
    }
  }

  var classes = classnames("hc-c-header hc-c-header--".concat(variation()), props.className);
  var hasCustomLinks = !!props.links;
  var defaultLinksForVariation = defaultMenuLinks({
    locale: props.initialLanguage,
    deConsumer: props.deConsumer,
    subpath: props.subpath,
    primaryDomain: props.primaryDomain,
    switchLocaleLink: props.switchLocaleLink,
    hideLoginLink: props.hideLoginLink,
    hideLogoutLink: props.hideLogoutLink,
    hideLanguageSwitch: props.hideLanguageSwitch,
    customLinksPassedIn: hasCustomLinks
  })[variation()];
  var links = hasCustomLinks ? props.links.concat(defaultLinksForVariation) : defaultLinksForVariation;
  return /*#__PURE__*/React.createElement("header", {
    className: classes,
    role: "banner",
    "aria-label": "global"
  }, /*#__PURE__*/React.createElement(SkipNav, {
    href: props.skipNavHref,
    onClick: props.onSkipNavClick
  }, t('header.skipNav')), /*#__PURE__*/React.createElement("div", {
    className: "ds-l-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ds-l-row ds-u-align-items--center ds-u-flex-wrap--nowrap ds-u-padding-y--2"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.primaryDomain ? props.primaryDomain : '/',
    className: "hc-c-logo-link ds-l-col ds-l-col--auto"
  }, /*#__PURE__*/React.createElement(Logo, {
    locale: (_props$initialLanguag = props.initialLanguage) !== null && _props$initialLanguag !== void 0 ? _props$initialLanguag : getLanguage(),
    className: (_props$logoClassName = props.logoClassName) !== null && _props$logoClassName !== void 0 ? _props$logoClassName : ''
  })), /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Profile, applications, and coverage",
    id: "hc-c-header__actions",
    className: "hc-c-header__actions ds-l-col ds-l-col--auto ds-u-margin-left--auto ds-u-font-weight--bold"
  }, /*#__PURE__*/React.createElement(ActionMenu, {
    t: t,
    firstName: props.firstName,
    onMenuToggleClick: handleMenuToggleClick,
    loggedIn: props.loggedIn,
    open: isControlledMenu ? props.isMenuOpen : openMenu,
    links: links
  }), /*#__PURE__*/React.createElement(Menu, {
    beforeLinks: beforeMenuLinks(),
    links: links,
    open: isControlledMenu ? props.isMenuOpen : openMenu,
    submenuTop: props.submenuTop,
    submenuBottom: props.submenuBottom
  })))), props.deConsumer && /*#__PURE__*/React.createElement(DeConsumerMessage, {
    t: t,
    deBrokerName: props.deBrokerName
  }), props.headerBottom);
};
Header.propTypes = {
  /**
     * Additional classes to be added to the root `<header>` element.
     */
  className: _pt.string,

  /**
     * For applications that handle their own locale switching. Overrides the
     * default locale link. The link's label is still determined by the opposite
     * of the `initialLanguage` provided, i.e. if `initialLanguage` is `en`,
     * the link's label will always be "Español". This takes precedence over the
     * `subpath` prop.
     */
  switchLocaleLink: _pt.string,

  /**
     * Indicate that a user is logged-in.
     */
  loggedIn: _pt.bool,

  /**
     * When set to true, do not display the Login text in the upper right of the
     * header
     */
  hideLoginLink: _pt.bool,

  /**
     * When set to true, even if logged in the Logout link will not render
     */
  hideLogoutLink: _pt.bool,

  /**
     * When set to true, do not display the the switch locale link
     */
  hideLanguageSwitch: _pt.bool,

  /**
     * For logged-in users, pass in their first name to display in the header
     */
  firstName: _pt.string,

  /**
     * For applications hosted at paths other than the root `healthcare.gov`/
     * `cuidadodesalud.gov`. This string will be appended to the end of the
     * language links so as to keep the user within the same part of the site
     * when switching languages.
     */
  subpath: _pt.string,

  /**
     * The primary, or root domain where the majority of header links should be
     * hosted.  By default, links render with relative paths, but providing this
     * prop will force all links to render with absolute paths based on the
     * provided string. The string should include the protocol (`http://` or
     * `https://`) and the domain only, with no trailing slash. For example, if
     * the provided string is `https://test.healthcare.gov`, the login link will
     * render as `https://test.healthcare.gov/login` instead of just `/login`.
     * Note that this is only really necessary if your application is hosted on a
     * subdomain, such as `https://localhelp.healthcare.gov`, where relative links
     * would direct the user to the wrong location, e.g. the link to `/login`
     * would incorrectly direct the user to
     * `https://localhelp.healthcare.gov/login` when it should direct the user to
     * `https://healthcare.gov/login`.
     */
  primaryDomain: _pt.string,

  /**
     * A URL hash used for the "Skip to main content" link. This is
     * typically the `id` of your "main" content area (ie. `#main`).
     */
  skipNavHref: _pt.string,

  /**
     * An onClick handler used for the "Skip to main content" link. This can
     * be used in cases where one would need to manually set the focus on the
     * content area (e.g. where hash routing is being used).
     */
  onSkipNavClick: _pt.func,

  /**
     * Indicates when a consumer is coming from a Direct Enrollment flow.
     * This will include additional messaging and modify some of the links.
     */
  deConsumer: _pt.bool,

  /**
     * Used in conjunction with `deConsumer`, the Direct Enrollment broker's
     * name is used in some of the messaging displayed to the consumer.
     */
  deBrokerName: _pt.string,

  /**
     * Optionally pass in an array of link objects to override the default
     * set of menu links. This may be useful if you need to customize the
     * links on a page-by-page basis. To reference the default set of menu
     * links, you can import the `defaultMenuLinks` method.
     */
  links: _pt.arrayOf(_pt.shape({
    href: _pt.string.isRequired,
    label: _pt.node.isRequired,
    ariaLabel: _pt.string.isRequired,
    className: _pt.string,
    onClick: _pt.func
  })),

  /**
     * Optionally pass a React component to render within the menu. Useful for
     * when you need more control over what appears in the menu than what's
     * provided by the `links` prop, e.g. a search input. Will appear *above* any
     * links provided by the `defaultMenuLinks` method or the links provided by
     * the `links` prop.
     */
  submenuTop: _pt.node,

  /**
     * Same as `submenuTop`, except it will appear *below* any links provided by
     * the `defaultMenuLinks` method or the links provided by the `links` prop.
     */
  submenuBottom: _pt.node,

  /**
     * Element added to display content on Header bottom section
     */
  headerBottom: _pt.node,

  /**
     * Open and handler function for fully controlled menu behavior
     */
  isMenuOpen: _pt.bool,
  onMenuToggle: _pt.func,

  /**
     * Additional classes to be added to the Logo component
     */
  logoClassName: _pt.string
};
Header.defaultProps = {
  skipNavHref: '#main'
};
export default Header;